module.exports = __webpack_public_path__ + "885b7af8ec9958bf8c8594d41345e070.pdf";